module.exports = __webpack_public_path__ + "static/media/background3.9cd4a037.jpg";